/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sourcedocument1Inputs */

const en_sourcedocument1 = /** @type {(inputs: Sourcedocument1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`document`)
};

const pt_sourcedocument1 = /** @type {(inputs: Sourcedocument1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`documento`)
};

/**
* | output |
* | --- |
* | "document" |
*
* @param {Sourcedocument1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const sourcedocument1 = /** @type {((inputs?: Sourcedocument1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourcedocument1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sourcedocument1(inputs)
	return pt_sourcedocument1(inputs)
});
export { sourcedocument1 as "sourceDocument" }